<template>
  <v-ons-page>
    <v-ons-toolbar class="home-toolbar">
      <div class="left">
        <v-ons-button modifier="quiet" style="margin: 6px 0" @click="goBack()">＜戻る</v-ons-button>
      </div>
      <div class="center" style="text-align: center;">{{ msg }}</div>
      <div class="right"></div>
    </v-ons-toolbar>
    <div class="header" style="text-align: center;">
      <img src="../../assets/lasmeru-logo-bold.png" width="200" height="200" style="margin-top: 50px; margin-bottom: 30px;">
    </div>


    <v-ons-list>
      <v-ons-list-item modifier="nodivider">
        <div class="center">
          メッセージ投稿を行いたいサービスとアカウント連携できます。<br>
          アカウント連携するサービスを選んで各サービスのアカウント認証を行ってください。
        </div>
      </v-ons-list-item>
      <v-ons-list-item modifier="nodivider">
        <div class="left">
          <v-ons-icon icon="fa-twitter" style="color: #1da1f2;"></v-ons-icon>
        </div>
        <div class="center">
          Twitterアカウントと連携する
        </div>
        <div class="right">
          <v-ons-button :disabled="selectedProvider !== ''" @click="authenticate('twitter')">連携</v-ons-button>
        </div>
      </v-ons-list-item>
      <!-- <v-ons-list-item modifier="nodivider">
        <div class="left">
          <v-ons-icon icon="fa-facebook" style="color: #1da1f2;"></v-ons-icon>
        </div>
        <div class="center">
          Facebookアカウントと連携する
        </div>
        <div class="right">
          <v-ons-button :disabled="selectedProvider !== ''" @click="authenticate('facebook')">連携</v-ons-button>
        </div>
      </v-ons-list-item> -->
      
      <div v-if="selectedProvider !== ''">
        <v-ons-list-item modifier="nodivider">
          <div class="center">
            <span style="color: #1da1f2;">
              アカウント認証用のポップアップウィンドウが表示されます。<br>
              認証作業が終わりポップアップウィンドウが自動で閉じた後に<br>
              連携したアカウントの情報を確認してください。
            </span>
          </div>
        </v-ons-list-item>
        <div v-if="showAuthInfo && authInfo">
          <v-ons-list-header>プロバイダー</v-ons-list-header>
          <v-ons-list-item modifier="nodivider">
            <div class="center">
              {{selectedProvider}}
            </div>
          </v-ons-list-item>
          <v-ons-list-header>アカウント名</v-ons-list-header>
          <v-ons-list-item modifier="nodivider">
            <div class="center">
              <span class="list-item__title" style="font-size: 0.9em;">
                {{ authInfo.profileName }}＠{{ authInfo.profileScreenName }}
              </span>
            </div>
          </v-ons-list-item>
        </div>
        <div v-else-if="showAuthInfo && !authInfo">
          <v-ons-list-item modifier="nodivider">
            <div class="center">
              アカウント連携した情報はありません。
            </div>
          </v-ons-list-item>
        </div>
      </div>
    </v-ons-list>

  </v-ons-page>
</template>

<script>
import firebase from 'firebase'
import common from '../../util/common'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import VueAuthenticate from 'vue-authenticate'
import axios from 'axios'

Vue.use(VueAxios, axios)
Vue.use(VueAuthenticate, {
  tokenName: 'access_token',
  // baseUrl: 'http://127.0.0.1:5000', // Your API domain
  baseUrl: 'https://miley-auth.web.app', // Your API domain
  providers: {
    twitter: {
      clientId: 'hfjDjTyj2aAyPoD003wL5t5ah',
      url: '/auth/twitter',
      // redirectUri: 'http://127.0.0.1:5000/auth/twitter/callback'
      redirectUri: 'https://miley-auth.web.app/auth/twitter/callback'
    }
    // facebook: {
    //   clientId: '729353711150751', // your Facebook App ID e.g. 12345667890
    //   redirectUri: 'https://localhost:5000/auth/facebook/callback', // Your client app URL
    //   responseType: 'token',
    //   authorizationEndpoint: 'https://www.facebook.com/v7.0/dialog/oauth'
    // }
  }
})

export default {
  name: 'OpenAuth',
  mixins: [common],
  data () {
    return {
      msg: 'アカウント連携',
      selectedProvider: '',
      showAuthInfo: false,
      authInfo: [],
      spinning: false
    }
  },

  created () {
  },

  mounted () {
  },

  computed: {
  },

  watch: {
  },

  methods: {
    authenticate: function (provider) {
      const self = this

      if (provider === 'twitter') {
        if (this.isTwitter) {
          this.$ons.notification.alert('すでに連携しているアカウントが<br>存在します。')
          return
        }
      }

      this.selectedProvider = provider

      this.$auth.authenticate(provider)
        .then(function (authResponse) {
          console.log('Auth Success!!')
          console.log('Provider: ', provider)
          console.log('authResponse: ', authResponse)
        // Execute application logic after successful social authentication
        })
        .catch((error) => {
          console.log('Auth Error!', error)
          self.getAuthInfo(self.selectedProvider, error)
        })
    },
    // getAuthInfo (provider) {
    //   const self = this
    //   const userRef = firebase.firestore().collection('/users').doc(this.user.userId)
    //   const authRef = userRef.collection('auth')

    //   authRef.where('provider', '==', provider).get()
    //     .then((snapshot) => {
    //       if (snapshot.size > 0) {
    //         let recv = []
    //         for (let i = 0; i < snapshot.size; i++) {
    //           recv.push(snapshot.docs[i].data())
    //         }
    //         self.authInfo = recv
    //       } else {
    //         self.authInfo = []
    //       }
    //       self.showAuthInfo = true
    //     })
    //     .catch((err) => {
    //       console.log('Error setTokens!: ', err)
    //       self.spinning = false
    //       self.$ons.notification.alert('送信エラー！<br>通信環境の安定している<br>場所で操作してください。')
    //     })
    // },

    getAuthInfo (provider, error) {
      this.authInfo = JSON.parse(localStorage.getItem('auth-info'))

      this.showAuthInfo = true
      if (this.authInfo) {
        this.setTokens(provider, this.authInfo)
      } else {
        this.$ons.notification.alert('認証に失敗しました。<br>', error)
      }
      localStorage.setItem('auth-info', '')
    },
    setTokens (provider, obj) {
      const self = this
      const userRef = firebase.firestore().collection('/users').doc(this.user.userId)
      const authRef = userRef.collection('auth')

      authRef.doc(obj.profileIdStr).set(obj)
        .then(function () {
          self.spinning = false
          self.$ons.notification.alert('アカウント連携しました。<br>左上の「戻る」を押してください。')
        })
        .catch((err) => {
          console.log('Error setTokens!: ', err)
          self.spinning = false
          self.$ons.notification.alert('送信エラー！<br>通信環境の安定している<br>場所で操作してください。')
        })
    }
  }
}
</script>

<style scoped>
@import "../../../src/assets/css/miley.css";
</style>



// WEBPACK FOOTER //
// src/components/auth/OpenAuth.vue